/**
 * Chemins de l'ecran « Conflits » (registre des conflits de synchronisation,
 * ADR 0039, #635).
 *
 * Module **pur**, importe par l'ecran, `App.tsx`, le registre de navigation
 * (`src/ui/navigation.ts`) et les ecrans qui renvoient vers lui — la fiche d'un
 * compte, la supervision des synchronisations, la carte « À traiter ». Ecrire le
 * chemin en clair a chacun de ces endroits reviendrait a le maintenir cinq fois.
 *
 * Liste + detail (`MasterDetail`) : une seule route `<base>/*` monte l'ecran, la
 * selection (`<base>/<id>`) vit dans l'URL, et le registre pointe la **base**.
 */

export const CONFLICTS_PATH = '/operations/conflicts';

export const CONFLICTS_ROUTE = `${CONFLICTS_PATH}/*`;

/** Les conflits d'un compte, tous etats et toute periode confondus : un conflit ouvert depuis longtemps ne doit pas disparaitre d'une fenetre. */
export const accountConflictsPath = (userId: string): string =>
  `${CONFLICTS_PATH}?${new URLSearchParams({ userId }).toString()}`;
